import { postFetch } from '../fetch';

import { apiConfig } from '../config';

export function postLessonAssigns({ assignments, clessonId, courseId }: any) {
    const { apiPostLessonAssigns } = apiConfig.getStaticUrls();

    return postFetch(apiPostLessonAssigns, {
        lessonAssigns: JSON.stringify(assignments),
        clesson: clessonId,
        course: courseId,
    });
}
